import React, { useCallback, useContext, useState } from "react";
import { INIT_FILTER_STATE } from "../../../../constants/driveglobalfilterinitialstates_coral";
import FilterSecondPageErc_Jupiter from "./FilterSecondPageErc_Jupiter";
import TopkpisSecondErc_Jupiter from "./TopkpisSecondErc_Jupiter";
import TopkpisSecondMainErc_Jupiter from "./TopkpisSecondMainErc_Jupiter";
import WaterMark from "../../DashboardMain_Jupiter/WaterMark";
import TableMainErc_Jupiter from "./TableMainErc_Jupiter";
import RangeSecondErc_Jupiter from "./RangeSecondErc_Jupiter";
import NetEnergySecondErc_Jupiter from "./NetEnergySecondErc_Jupiter";
import SocDisErc_Jupiter from "./SocDisErc_Jupiter";
import DischargeDurErc_Jupiter from "./DischargeDurErc_Jupiter";
import CycleVsRange_Jupiter from "./CycleVsRange_Jupiter";
import BmsCellTemp_Jupiter from "./BmsCellTemp_Jupiter";
import BmsDeltaCellVolt_Jupiter from "./BmsDeltaCellVolt_Jupiter";
import McuContTemp_Jupiter from "./McuContTemp_Jupiter";
import MotorTempErc_Jupiter from "./MotorTempErc_Jupiter";
import DcdcTemp_Jupiter from "./DcdcTemp_Jupiter";

function PageSecondErc_Jupiter(props) {
  const [secondPageState, setSecondPageState] = useState({
    startDate: props.gloablfilter.startDate,
    endDate: props.gloablfilter.endDate,
    VIN_NUM: props.gloablfilter.VIN_NUM.toString(),
    soc_per: props.gloablfilter.SOC,
  });
 

  const filterSubmited = useCallback((data) => {
    setSecondPageState(data);
  }, []);

  const pageChange = useCallback((data) => {
    props.pageChange();
  }, []);

  return (
    <>
      <FilterSecondPageErc_Jupiter
        onsubmit={filterSubmited}
        pageChange={pageChange}
        secondPageState={secondPageState}
      />
      <div className="container-fluid">
        <TopkpisSecondErc_Jupiter
          gloablfilter={secondPageState}
          apiend="jupiter_drive_analysis/topkpis_erc"
        />
        <TopkpisSecondMainErc_Jupiter
          gloablfilter={secondPageState}
          apiend="jupiter_drive_analysis/topkpismain_erc"
        />
        <section className="graphs">
          <div className="row">
            <div className="col-md-6 col-sm-12 col-lg-3 pr-1 drive_graph">
              <WaterMark />
              <TableMainErc_Jupiter
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/tabledata_erc"
              ></TableMainErc_Jupiter>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <RangeSecondErc_Jupiter
                title="Real World Range Distribution"
                
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/bar_chart_erc"
              ></RangeSecondErc_Jupiter>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <NetEnergySecondErc_Jupiter
                title="Net Energy Consumption"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/bar_chart_erc"
              ></NetEnergySecondErc_Jupiter>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-2">
              <WaterMark />
              <SocDisErc_Jupiter
                title="SoC Discharge/Cycle"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/bar_chart_erc"
              ></SocDisErc_Jupiter>
            </div>
          </div>

          <div className="row mt-2 pt-2">
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <DischargeDurErc_Jupiter
                title="Median Discharge Duration"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/bar_chart_erc"
              ></DischargeDurErc_Jupiter>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <CycleVsRange_Jupiter
                title="Range Trend Line"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/cycle_vs_range_erc"
              ></CycleVsRange_Jupiter>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-1">
              <WaterMark />
              <BmsCellTemp_Jupiter
                title="BMS Max Cell Temperature"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/bms_cell_temp_erc"
              ></BmsCellTemp_Jupiter>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-3 drive_graph pr-2">
              <WaterMark />
              <BmsDeltaCellVolt_Jupiter
                title="BMS Delta Cell Voltage"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/bms_delta_temp_erc"
              ></BmsDeltaCellVolt_Jupiter>
            </div>
          </div>

          <div className="row mt-2 pt-1">
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-0">
              <WaterMark />
              <McuContTemp_Jupiter
                title="MCU  Temperature"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/mcu_temp_erc"
              ></McuContTemp_Jupiter>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-0">
              <WaterMark />
              <MotorTempErc_Jupiter
                title="Motor Temperature"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/motor_temp_erc"
              ></MotorTempErc_Jupiter>
            </div>
            <div className="col-md-6 col-sm-12 col-lg-4 drive_graph pr-1">
              <WaterMark />
              <DcdcTemp_Jupiter
                title="DCDC Temperature"
                gloablfilter={secondPageState}
                apiend="jupiter_drive_analysis/dcdc_temp_erc"
              ></DcdcTemp_Jupiter>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PageSecondErc_Jupiter;
